var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.series.length)?_c('apexchart',{ref:"chart",attrs:{"type":"bar","options":_vm.chartOptions,"series":_vm.series,"width":_vm.width}}):_c('div',[_vm._v("No hay datos disponibles")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }